import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, useHistory } from 'react-router-dom';
import Authorize from "../Authorize";
import * as Roles from "../../resources/UserRole";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import { useFilter } from '../../hooks/InvoiceFilterContext';


export const ActiveInvoices = (props) => {
    const { clearFilters, updateFilter } = useFilter();
    const history = useHistory();
  const pastDueInvoiceData = props.invoiceData;
  const isEnglish = props.storeSettings.locale == "en_US";
  const pastDueCount = Object.values(pastDueInvoiceData).filter(
    (x) => x.orderDate < new Date().toLocaleDateString("en-CA")
  ).length;
  const classNameSizeTop = isEnglish ? "font-size-20" : "font-size-28";
  const classNameSizeBottom = isEnglish ? "font-size-28" : "font-size-20";

    const redirectLink = () => {
        if (window.location.href.includes("dv") || window.location.href.includes("localhost") || window.location.href.includes("py")) {
            return props.isFueling ? "https://eip-test-ffs.fele.com/" : "https://eip-test-wat.fele.com/";
        }
        else {
            return props.isFueling ? "https://payment.franklinfueling.com" : "https://payment.franklinwater.com";
        }
    }

    const handleInvoiceFilterClick = () => {
        clearFilters();
        updateFilter('dateRange', 730);
        if (pastDueCount > 0) {
            updateFilter('pastDueOnly', true);
        }
        history.push({
            pathname: "/invoices",
            query: { days: 730 },
            ...(pastDueCount > 0 && { state: { pastDueOnly: true } }),
        });
    };

  return (
    <>
      {props.storeSettings.settingsList.UseDashboardActiveInvoices == "1" && (
              <>
                  <div className="green-box" style={{ justifyContent:"space-between", width: "400px", paddingLeft: "10px", display:"flex" }}>
                <div>
                    <button
                        style={{ all: 'unset', cursor: 'pointer' }}
                        onClick={handleInvoiceFilterClick}
                    >
                        <div className="flex">
                            <RequestQuoteOutlinedIcon
                                style={{
                                  color: "gray",
                                  height: "6rem",
                                  width: "min-content",
                                          marginTop: "19px",
                                  marginRight: "-10px"
                                      }}
                            />
                            <div className="big-number">
                                <div className="font-size-64">
                                    {pastDueInvoiceData.length}
                                </div>

                                <div className="label-wrapper">
                                    <div
                                        className={classNameSizeTop}
                                        style={{
                                          color:
                                            pastDueCount > 0 && isEnglish ? "#118ABD" : "black",
                                          whiteSpace: "nowrap",
                                        }}
                                    >
                                        {pastDueCount > 0
                                            ? props.dashboardLabels.PAST_DUE
                                            : props.dashboardLabels.Open}
                                    </div>

                                    <div
                                        className={classNameSizeBottom}
                                        style={{
                                            color:
                                                pastDueCount > 0 && !isEnglish
                                                ? "#118ABD"
                                                : "black",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {props.dashboardLabels.INVOICES}
                                    </div>
                                </div>
                             </div>
                        </div>
                    </button>
                      </div>
                      <div style={{ textWrap:"nowrap" }}>
                <Authorize
                     hasRoles={[Roles.HAS_PAYMENT_PORTAL_ACCESS]}
                     displayMessage={false}
                 >
                    <Link
                        className="link-style"
                        to={{
                            pathname: redirectLink(),
                        }}
                        target="_blank"
                    >
                        <button
                            style={{
                                borderRadius: "4px",
                                border: "none",
                                background: "#7ebd42",
                                color: "white",
                                padding: "7px",
                                margin: "10px",
                                float: "right",
                            }}
                        >
                            {props.dashboardLabels.Pay_Now}
                        </button>
                    </Link>
                </Authorize>
              </div>
          </div>
        </>
      )}
    </>
  );
};

ActiveInvoices.propTypes = {
  orderData: PropTypes.object,
};
function mapStateToProps(state) {
  return {
    selectedCustomer: state.user.selectedCustomer,
  };
}

export default connect(mapStateToProps, null)(ActiveInvoices);
